export default () => ({
  initCountdown(date, time, sectionId) {
    window && dayjs.extend(window.dayjs_plugin_utc);
    window && dayjs.extend(window.dayjs_plugin_timezone);

    var timestamp = date + " " + time;

    var d = dayjs.tz(timestamp, "Europe/Stockholm");

    var countDownDate = d.valueOf();

    var isInvalidDate = isNaN(countDownDate);

    if (isInvalidDate) {
      document.getElementById(`days-${sectionId}`).innerHTML = "INVALID DATE";
      return;
    }

    var x = setInterval(function () {
      // Get today's time in milliseconds
      var n = dayjs.utc();
      var now = n.valueOf();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Display the result in the element with id
      document.getElementById(`days-${sectionId}`).innerHTML = days + "D";
      document.getElementById(`hours-${sectionId}`).innerHTML = hours + "H";
      document.getElementById(`minutes-${sectionId}`).innerHTML = minutes + "M";
      document.getElementById(`seconds-${sectionId}`).innerHTML = seconds + "S";

      // If the countdown is finished
      if (distance < 0) {
        clearInterval(x);
        document.getElementById(`days-${sectionId}`).innerHTML =
          "COUNTDOWN FINISHED";
        document.getElementById(`hours-${sectionId}`).innerHTML = "";
        document.getElementById(`minutes-${sectionId}`).innerHTML = "";
        document.getElementById(`seconds-${sectionId}`).innerHTML = "";
      }
    }, 1000);

    // Display end countdown time
    document.getElementById(`fullTime-${sectionId}`).innerHTML =
      d.format("HH") + ":" + d.format("mm") + " (GMT+1)";
    document.getElementById(`fullDate-${sectionId}`).innerHTML =
      d.date() + " " + d.format("MMMM");
  },

  initHeight() {
    var height = this.$refs.textWrapper && this.$refs.textWrapper.clientHeight;
    this.$refs.stickyDiv &&
      (this.$refs.stickyDiv.style.height = `calc(100% - ${height}px)`);
  },
});
